export const GET_CATEGORY_ROOT = "GET_CATEGORY_ROOT";
export const GET_CATEGORY_CHILD = "GET_CATEGORY_CHILD"
export const GET_NOTIFICATION = "GET_NOTIFICATION"
export const GET_SPECIFIC_DETAIL = "GET_SPECIFIC_DETAIL";
export const GET_TIMESLOTS_TYPE = 'GET_TIMESLOTS_TYPE';
export const GET_TIMESLOTS_LIST = 'GET_TIMESLOTS_LIST';